<template>
  <div>
<!--    <div class="pure_top"></div>-->
    <Header :title="$t('home.activity')"/>

    <van-notice-bar v-if="notice.content" scrollable :text="notice.content" />

    <div class="wrapper">
      <div class="user">
        <div class="phone">
          <img src="../images/team/tm1.png" class="tmimg" model="widthFix" v-if="tlevel == 1">
          <img src="../images/team/tm2.png" class="tmimg" model="widthFix" v-if="tlevel == 2">
          <img src="../images/team/tm3.png" class="tmimg" model="widthFix" v-if="tlevel == 3">
          <img src="../images/team/tm4.png" class="tmimg" model="widthFix" v-if="tlevel == 4">
          <img src="../images/team/tm5.png" class="tmimg" model="widthFix" v-if="tlevel == 5">
          <img src="../images/team/tm6.png" class="tmimg" model="widthFix" v-if="tlevel == 6">
          {{ data.phone }}
        </div>
        <p v-clipboard="() => data.share_link" v-clipboard:success="copy" class="clipboard">
          {{ $t("invest_bank.copy") }}
        </p>
      </div>

      <div class="mySet">
        <div class="mySet-ul flex-p">
          <div class="mySet-li mySet-li-m flex-p" @click="$router.push('/teamAward')">
            <div class="item_img">
              <img src="../images/team/sign.png" alt="" />
            </div>
            <p class="item_title">{{ $t("Team Rewards") }}</p>
          </div>
<!--          <div class="mySet-li flex-p">-->
          <div class="mySet-li flex-p" @click="$router.push('/ranking')">
            <div class="item_img">
              <img src="../images/team/rules.png" alt="" />
            </div>
            <p class="item_title">{{ $t("Rankings") }}</p>
          </div>
        </div>
        <div class="mySet-ul flex-p" v-if="tlevel > 0">
          <div class="mySet-li mySet-li-m flex-p" @click="$router.push('/allTeam')">
            <div class="item_img">
              <img src="../images/team/sign.png" alt="" />
            </div>
            <p class="item_title">{{ $t("user.AllTeam") }}</p>
          </div>
          <div class="mySet-li flex-p" @click="$router.push('/teamBill')">
            <div class="item_img">
              <img src="../images/team/rules.png" alt="" />
            </div>
            <p class="item_title">{{ $t("user.TeamBill") }}</p>
          </div>
        </div>
      </div>

      <div class="amount">
        <div style="width:50%">
          <p class="money">{{ data.countCommission }}</p>
          <p style="
            text-align: center;
            padding-bottom: 10px;
            border-bottom: 1px solid rgb(205, 205, 205);
          ">
            {{ $t("share.commission") }}
          </p>
        </div>
        <div style="width:50%">
          <p class="money">{{ data.teamTotals }}</p>
          <p style="
            text-align: center;
            padding-bottom: 10px;
            border-bottom: 1px solid rgb(205, 205, 205);
          ">
            {{ $t("share.teamAll") }}
          </p>
        </div>
      </div>
      <div class="tabs">
        <p :class="active == 1 ? 'active' : ''" @click="change(1)">
          {{ $t("share.level1") }}({{ countTop1 }})
        </p>
        <p :class="active == 2 ? 'active' : ''" @click="change(2)">
          {{ $t("share.level2") }}({{ countTop2 }})
        </p>
        <p :class="active == 3 ? 'active' : ''" @click="change(3)">
          {{ $t("share.level3") }}({{ countTop3 }})
        </p>
      </div>
      <div class="list">
        <div class="item" v-for="(i, index) in teamList" :key="index">
          <div>
            <p class="phone">{{ i.phone }}</p>
            <p class="time">{{ i.time }}</p>
          </div>
          <div class="level">
            {{ i.level }}
          </div>
        </div>
      </div>
      <van-empty :description="$t('item.noData')" v-if="listLength" />
    </div>
    <div style="height: 80px">&nbsp;</div>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import bsHeader from "../../components/bsHeader.vue";
import Header from "@/components/Header";
import Vue from "vue";
import { Empty } from "vant";
import Clipboard from "v-clipboard";
Vue.use(Empty).use(Clipboard);
export default {
  name: "myTeam",
  data() {
    return {
      data: {},
      countTeam: 0,
      countTop1: 0,
      countTop2: 0,
      countTop3: 0,
      tlevel: 0,
      active: 1,
      teamList: [],
      listLength: true,
      qrcode: false,
      Langu: 'en_us',
      notice: {},
    };
  },
  components: {
    bsHeader,
    Header
  },
  created() {
    this.$parent.footer("cart", true);
    this.Langu = localStorage.getItem("lang")||"en_us";
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch("/user/myTeam").then((r) => {
        console.log(r);
        this.data = r.data;
        this.teamList = r.data.top1;
        if (r.data.top1.length == 0) {
          this.listLength = true;
        } else {
          this.listLength = false;
        }
        this.countTop1 = r.data.top1.length;
        this.countTop2 = r.data.top2.length;
        this.countTop3 = r.data.top3.length;
        this.tlevel = r.data.tlevel;

        this.countTeam = this.countTop1 + this.countTop2;

        this.notice = r.data.notice;
      });
    },
    change(num) {
      this.active = num;
      this.teamList = this.data["top" + num];
      if (this.teamList.length == 0) {
        this.listLength = true;
      } else {
        this.listLength = false;
      }
    },
    copy({ value, event }) {
      var input = document.createElement("input"); // 创建input对象
      input.value = value; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$toast({
        background: "#07c160",
        message: this.$t("invest_qrcode.copySucceeded"),
      });
    },
    downLoad() {
      /*var that = this;
           jsBridge.saveImageToAlbum(this.data.share_image_url, function(succ) {
              that.$toast(succ ? "保存成功" : "保存失败：下载失败或没有相册使用权限");
          }); */
      this.downloadIamge(this.data.share_image_url, "share.jpg");
    },
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
  },
};
</script>

<style lang="less" scoped>
.pure_top {
  width: 100%;
  height: 300px;
  position: relative;
  z-index: 0;
  overflow: hidden;
  background: url("~@/assets/images/bg1.jpg");
  background-size: cover;
}
.wrapper {
  position: relative;
  width: 100%;
  margin-top: 20px;
}
.mySet {
  width: 90%;
  margin: 10px auto;

  .mySet-ul {
    margin-bottom: 15px;

    .mySet-li {
      background: #47b897;
      box-shadow: 1px 3px 9px 0px rgba(0, 0, 0, 0.14);
      border-radius: 30px;
      width: 45%;
      padding: 9px 0;

      .item_img {
        margin-right: 10px;

        img {
          width: 22px;
          height: 22px;
        }
      }

      .item_title {
        font-size: 15px;
        font-family: PingFang;
        font-weight: bold;
        color: #FFFFFF;
      }
    }

    .mySet-li-m {
      margin-right: 10px;
    }
  }
}
.list {
  .item {
    width: 90%;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 10px;
    margin-bottom: 15px;
    box-shadow: 2px 2px 4px #d3d3d3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;

    .phone {
      font-size: 20px;
      margin-bottom: 10px;
    }

    .level {
      color: #e7c78a;
      font-size: 24px;
    }
  }
}

.tabs {
  width: 90%;
  margin: 0 auto;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  p {
    background-color: #3e3e3c;
    padding: 10px 20px;
    color: #ffffff;
    border-radius: 10px;
  }

  .active {
    background: #76b900;
    color: #ffffff;
  }
}

.amount {
  width: 90%;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 10px;
  margin-bottom: 15px;
  box-shadow: 2px 2px 4px #d3d3d3;
  height: 130px;
  align-items: center;
  display: flex;
  text-align: center;
  justify-content: center;

  .money {
    color: #e7c78a;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 10px;
  }
}

.user {
  width: 90%;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 20px;
  margin-bottom: 15px;
  box-shadow: 2px 2px 4px #d3d3d3;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  .phone {
    color: #030303;
    font-size: 16px;
    font-weight: bold;
  }

  .clipboard {
    background-color: #76b900;
    color: #ffffff;
    border-radius: 20px;
    padding: 7px 30px;
    text-align: center;
    font-size: 14px;
  }
}
.tmimg{
  width: 25px;
  position: relative;
  top: 5px;
}
</style>
